import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "navbar__inner" }
const _hoisted_2 = ["aria-label"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["navbar", { 'navbar--scrolled': $setup.scrolled, 'navbar--open': $setup.menuOpen }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "navbar__logo",
        onClick: _cache[0] || (_cache[0] = $event => ($setup.menuOpen = false))
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" E ", -1 /* CACHED */),
          _createElementVNode("span", { class: "navbar__ampersand" }, "&", -1 /* CACHED */),
          _createTextVNode(" A ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("button", {
        class: "navbar__toggle",
        "aria-label": $setup.menuOpen ? 'Fermer le menu' : 'Ouvrir le menu',
        onClick: _cache[1] || (_cache[1] = $event => ($setup.menuOpen = !$setup.menuOpen))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["navbar__toggle-line", { 'navbar__toggle-line--open': $setup.menuOpen }])
        }, null, 2 /* CLASS */),
        _createElementVNode("span", {
          class: _normalizeClass(["navbar__toggle-line", { 'navbar__toggle-line--open': $setup.menuOpen }])
        }, null, 2 /* CLASS */),
        _createElementVNode("span", {
          class: _normalizeClass(["navbar__toggle-line", { 'navbar__toggle-line--open': $setup.menuOpen }])
        }, null, 2 /* CLASS */)
      ], 8 /* PROPS */, _hoisted_2),
      _createElementVNode("ul", {
        class: _normalizeClass(["navbar__links", { 'navbar__links--open': $setup.menuOpen }])
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.links, (link) => {
          return _createElementVNode("li", {
            key: link.to
          }, [
            _createVNode(_component_router_link, {
              to: link.to,
              class: "navbar__link",
              "active-class": "navbar__link--active",
              onClick: _cache[2] || (_cache[2] = $event => ($setup.menuOpen = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(link.label), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
          ])
        }), 64 /* STABLE_FRAGMENT */))
      ], 2 /* CLASS */)
    ])
  ], 2 /* CLASS */))
}